import { Box, Container, Heading, SimpleGrid } from '@chakra-ui/react'
import { NextPage } from 'next'
import groupBy from 'lodash.groupby'
import sortBy from 'lodash.sortby'
import SEO from 'components/SEO'
import SpecialistCard from 'components/SpecialistCard'

type Specialist = Record<string, any>

interface TeamProps {
  specialists: Specialist[]
}

const Team: NextPage<TeamProps> = ({ specialists }) => {
  const specialistsWithPriority = specialists.map((specialist) => ({
    ...specialist,
    specialityPriority: specialist.attributes.speciality?.data?.attributes?.displayPriority
  }))
  const grouppedSpecialists = groupBy(specialistsWithPriority, 'attributes.speciality.data.attributes.name')
  const listsEntries = Object.entries(grouppedSpecialists)
  const sortedLists = sortBy(listsEntries, '[1][0].specialityPriority').reverse()

  return (
    <Container maxWidth="container.xl" marginY="3rem">
      <SEO
        title="Lekarze, prywatna przychodnia w Poznaniu"
        description="Medwind to zespół czołowych w swoich dziedzinach specjalistów z wieloletnim doświadczeniem. W zespole znajdziecie Państwo Ortopedów, Chirurgów, Otolaryngologów, Fizjoterapeutów, Psychologów, Dietetyków, Logopedów."
      />
      <Heading size="lg">Nasz zespół</Heading>
      {sortedLists?.map(([groupName, specialistsList]) => {
        const sortedSpecialists = sortBy(specialistsList, 'attributes.displayPriority').reverse()
        return (
          <Box key={groupName} marginTop="2rem">
            <Heading size="md">{groupName !== 'undefined' ? groupName : '-'}</Heading>
            <SimpleGrid columns={[1, 2, 3]} marginTop="2rem" gap="2rem" alignItems="flex-start">
              {sortedSpecialists?.map((specialist, i) => (
                <SpecialistCard key={i} specialist={specialist} />
              ))}
            </SimpleGrid>
          </Box>
        )
      })}
    </Container>
  )
}

export async function getServerSideProps() {
  const URL = `${process.env.NEXT_PUBLIC_API_URL}/api/specialists?populate=speciality,photo`
  const res = await fetch(URL)
  const { data } = await res.json()
  return { props: { specialists: data } }
}

export default Team
